import { useDialog, useMobileMenu, usePlatformStore } from "@platform/store";
import { useFetchUserCircles } from "@core/features/circle";
import { ProgramCircleParticipantsDialog } from "./ProgramCircleParticipantsDialog";

export function ProgramCircleParticipantsContainer() {
  const { activeDialog, closeDialog } = useDialog();
  const user = usePlatformStore((s) => s.user);

  const { close: closeMobileMenu } = useMobileMenu();

  const isOpen = activeDialog === "circle";

  const { data: circlesData } = useFetchUserCircles({ user });
  const circle = circlesData?.circles?.[0];

  const handleDone = async () => {
    // close the dialog
    closeDialog();

    closeMobileMenu();
  };

  return (
    <ProgramCircleParticipantsDialog
      participants={circle?.users}
      onClose={handleDone}
      isOpen={isOpen}
    />
  );
}

export default ProgramCircleParticipantsContainer;

